import { useUpdateLoyaltyConfigMutation } from '@/services/innovorder/modules/modules.endpoints';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { UpdateComoConfigForm } from './ComoConfigUpdateForm';
import { UpdateLoyaltyConfigPayload } from '@/services/innovorder/modules/modules.type';
const useUpdateComoConfig = () => {
    const { restaurantId } = useParams<{ restaurantId: string }>();
    const [updateComoConfig, { isLoading: isUpdating, isSuccess: isUpdateSuccess }] = useUpdateLoyaltyConfigMutation();

    const {
        control,
        handleSubmit,
        formState: { isDirty, isValid },
    } = useForm<UpdateComoConfigForm>({
        mode: 'all',
    });

    const onSubmit = (data: UpdateComoConfigForm) => {
        updateComoConfig({
            restaurantId: Number(restaurantId),
            formLink: data.formLink || null,
            useCasualTone: data.useCasualTone,
            provider: 'como',
            authenticationMethods: data.authenticationMethods,
            registerMethods: data.registerMethods,
            features: data.features,
        } as UpdateLoyaltyConfigPayload);
    };

    return { control, handleSubmit, onSubmit, isUpdating, isDirty, isUpdateSuccess, isValid };
};

export default useUpdateComoConfig;
